module.exports = __webpack_public_path__ + "lato-bold-webfont.0184b5957d339924ac27.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-bold-webfont.woff2
// module id = ../../../../../resources/layout/fonts/lato-bold-webfont.woff2
// module chunks = styles